//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {deviceSort} from './js/deviceListSort'
import {findSupportConnectDevice} from '../../../utils/device/deviceConnect'
import {aligenie} from '../../../utils/tmallGenius'

export default {
  name: "devicePanel",
  props: [
    'deviceList', //后台传来的设备列表
  ],
  data() {
    return {
      deviceListSorted: [], //分类后的设备列表
    };
  },
  /*------------------------------------------- 开始运行 -------------------------------------------------------*/
  created() {
    this.deviceListSorted = deviceSort(this.deviceList);
  },
  methods: {
    /*------------------------------------------- 自定义方法 -------------------------------------------------------*/
    /*  找到相应设备类型的图片
    * */
    findImg(device) {
      let src = '';
      const deviceInfo = findSupportConnectDevice(device);
      try {
        src = require('../../../assets/img/home/sub/' + device.deviceType + '.png'); //找到图片
        if (deviceInfo) {
          try {
            src = require('../../../assets/img/home/sub/' + device.deviceType + '.' + deviceInfo.name + '.png'); //尝试找更深一层的
          } catch (err) {
          }
        }
      } catch (err) {
        if (err) src = require('../../../assets/img/home/sub/other.png'); //找不到用默认的
      }
      return src;
    },
    /*  获取房间名字
    * */
    getRoomName(aligenieZone, roomName) {
      return aligenie.getRoomName(aligenieZone, roomName);
    },
    /*------------------------------------------- 绑定方法 -------------------------------------------------------*/
    /*  点击“配置”，去控制器页面
    * @param {obj}device设备信息
    * */
    controllerClick(device) {
      let deviceInfo = findSupportConnectDevice(device);
      let query = {
        deviceId: device.deviceId,
        uid: device.uid,
        aligenieZone: aligenie.getRoomName(device.aligenieZone, device.roomName),
        deviceName: device.deviceName,
      };
      this.$router.push({
        path: deviceInfo.link,
        query: query
      });
    },
    /*  点击设备，去设备详情
    * @param {obj}device设备信息
    * */
    deviceClick(device) {
      let deviceInfo = findSupportConnectDevice(device);
      //参数
      let query = {
        deviceId: device.deviceId,
        deviceType: device.deviceType,
        uid: device.uid,
        bid: parseInt(device.irDeviceId) || '',
      };
      if (deviceInfo) { //在前端有数据的可控设备
        if (deviceInfo.kookongDeviceType) query.kookongDeviceType = deviceInfo.kookongDeviceType; //遥控的，添加酷控号码
        if (deviceInfo.functionType) query.functionType = deviceInfo.functionType;
      }
      this.$router.push({
        path: "/settings",
        query: query,
      });
    },
  }
};



// WEBPACK FOOTER //
// ./src/pages/Home/deviceLIst/devicePanel.vue